import { CancelToken } from 'axios';

import API from '@app/api';
import Config from '@app/config';

import request from '@module/http/axios/request';

export default {
  cancelToken: null,

  allocateImage(accountId, type, filename, curated = false) {
    const imageModelClassMapping = {
      wallpaper: 'Wallpaper',
      profile_picture: 'ProfilePicture',
      email_background: 'EmailBackground',
    };

    const options = {
      asset_model_class: imageModelClassMapping[type],
      account_id: accountId,
    };

    if (curated) {
      options.image_path = filename;
      return API.UI.allocateCuratedImage(options);
    }

    options.original_asset_filename = filename;
    return API.UI.allocateImage(options);
  },

  uploadImage(presignedUrl, contentType, file) {
    this.cancelToken = CancelToken.source();

    return request({
      method: 'put',
      path: presignedUrl,
      responseType: 'text',
      params: file.slice(),
      cancelToken: this.cancelToken.token,
      headers: {
        'Content-Type': contentType,
      },
    });
  },

  cancelUpload() {
    if (this.cancelToken !== null) {
      this.cancelToken.cancel();
      this.cancelToken = null;
    }
  },

  isFileSizeValid(type, size) {
    switch (type) {
      case 'wallpaper':
        return size <= Config.imageUpload.maxWallpaperSize;
      case 'email_background':
        return size <= Config.imageUpload.maxEmailBackgroundSize;
      case 'profile_picture':
        return size <= Config.imageUpload.maxProfilePictureSize;
      default:
        return false;
    }
  },
};
